import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Company Members
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type CompanymembersParameters = CompanymembersInvitationRemindCreatedParameters | CompanymembersInvitationCreatedParameters | CompanymembersMemberAddedParameters;
export type CompanymembersEvents = CompanymembersInvitationRemindCreatedEvent | CompanymembersInvitationCreatedEvent | CompanymembersMemberAddedEvent;

export interface CompanymembersInvitationRemindCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	context: string; // context of the invitation dialog, possible values are "company-members", "project-members", "project-creation", "onboarding"
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	isTrialSubscription?: boolean; // is event sent during trial subscription
	experiment?: string; // identifier for experiment, value could be any unique string according to experiment being performed
	experimentAssignment?: string; // variant of experiment, its value can be boolean, string or number
}

export type CompanymembersInvitationRemindCreatedParametersSpecific = Omit<
	CompanymembersInvitationRemindCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const companymembersInvitationRemindCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class CompanymembersInvitationRemindCreatedEventBuilder {
	constructor(private specificParameters: CompanymembersInvitationRemindCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<CompanymembersInvitationRemindCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			CompanymembersInvitationRemindCreatedParametersSpecific,
            CompanymembersInvitationRemindCreatedParameters,
			(params: CompanymembersInvitationRemindCreatedParameters) => CompanymembersInvitationRemindCreatedEvent
		>(this.specificParameters, companymembersInvitationRemindCreatedParametersGlobal, globalParams, (params) => new CompanymembersInvitationRemindCreatedEvent(params));
	}
}

/**
 * A user clicked on remind after a user got invited.
 */
export class CompanymembersInvitationRemindCreatedEvent extends CraftnoteEvent<CompanymembersInvitationRemindCreatedParameters>{
  constructor(parameters: CompanymembersInvitationRemindCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "companyInvite_remind_sent"
		},
		{
			name: "iterable",
			eventName: "companymembers_invitation_remind_created"
		},
	]);
  }
}
export interface CompanymembersInvitationCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	role: string; // role of the invited user, must be any of "owner", "supervisor", "employee"
	isTrialSubscription?: boolean; // is event sent during trial subscription
	experiment?: string; // identifier for experiment, value could be any unique string according to experiment being performed
	experimentAssignment?: string; // variant of experiment, its value can be boolean, string or number
	context: string; // context of the invitation dialog, possible values are "company-members", "project-members", "project-creation", "onboarding"
}

export type CompanymembersInvitationCreatedParametersSpecific = Omit<
	CompanymembersInvitationCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const companymembersInvitationCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class CompanymembersInvitationCreatedEventBuilder {
	constructor(private specificParameters: CompanymembersInvitationCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<CompanymembersInvitationCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			CompanymembersInvitationCreatedParametersSpecific,
            CompanymembersInvitationCreatedParameters,
			(params: CompanymembersInvitationCreatedParameters) => CompanymembersInvitationCreatedEvent
		>(this.specificParameters, companymembersInvitationCreatedParametersGlobal, globalParams, (params) => new CompanymembersInvitationCreatedEvent(params));
	}
}

/**
 * A user is invited into a company.
 */
export class CompanymembersInvitationCreatedEvent extends CraftnoteEvent<CompanymembersInvitationCreatedParameters>{
  constructor(parameters: CompanymembersInvitationCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "company_invitation_pool"
		},
		{
			name: "iterable",
			eventName: "companymembers_invitation_created"
		},
	]);
  }
}
export interface CompanymembersMemberAddedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	role: string; // the role of user, must be any of "owner", "supervisor", "employee"
}

export type CompanymembersMemberAddedParametersSpecific = Omit<
	CompanymembersMemberAddedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const companymembersMemberAddedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class CompanymembersMemberAddedEventBuilder {
	constructor(private specificParameters: CompanymembersMemberAddedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<CompanymembersMemberAddedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			CompanymembersMemberAddedParametersSpecific,
            CompanymembersMemberAddedParameters,
			(params: CompanymembersMemberAddedParameters) => CompanymembersMemberAddedEvent
		>(this.specificParameters, companymembersMemberAddedParametersGlobal, globalParams, (params) => new CompanymembersMemberAddedEvent(params));
	}
}

/**
 * The active user accepted an invitation into a company. The user either registered newly, or had an account before.
 */
export class CompanymembersMemberAddedEvent extends CraftnoteEvent<CompanymembersMemberAddedParameters>{
  constructor(parameters: CompanymembersMemberAddedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "company_employeeInvitation_accepted"
		},
		{
			name: "iterable",
			eventName: "companymembers_member_added"
		},
	]);
  }
}
